import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'ai-tool', {
    searchTaxonomy: 'Find taxonomy by tags',
    searchTaxonomyReasoning: 'Finding taxonomy by tags',
    searchTaxonomyOutput: 'Found {{count}} taxonomy items',
    searchTaxonomyNoop: 'No taxonomy items found',
    searchTaxonomyError: 'Error searching taxonomy',
    vectorSearchTaxonomy: 'Vector search taxonomy',
    vectorSearchTaxonomyReasoning: 'Vector searching taxonomy',
    vectorSearchTaxonomyOutput: 'Found {{count}} taxonomy items',
    vectorSearchTaxonomyNoop: 'No taxonomy items found',
    vectorSearchTaxonomyError: 'Error vector searching taxonomy',
    addTaxonomy: 'Add taxonomy',
    addTaxonomyReasoning: 'Adding taxonomy',
    addTaxonomyOutput: 'Added taxonomy item for review',
    addTaxonomyNoop: 'No taxonomy item added',
    addTaxonomyError: 'Error adding taxonomy',
    listTaxonomies: 'List taxonomies',
    listTaxonomiesReasoning: 'Listing taxonomies',
    listTaxonomiesOutput: 'Listed {{count}} taxonomies',
    listTaxonomiesNoop: 'No taxonomy items found',
    listTaxonomiesError: 'Error listing taxonomies',
    listTaxonomyPractices: 'List taxonomy practices',
    listTaxonomyPracticesReasoning: 'Listing taxonomy practices',
    listTaxonomyPracticesOutput: 'Listed {{count}} taxonomy practices',
    listTaxonomyPracticesNoop: 'No taxonomy practices found',
    listTaxonomyPracticesError: 'Error listing taxonomy practices',
    searchResources: 'Find resources by tags',
    searchResourcesReasoning: 'Finding resources by tags',
    searchResourcesOutput: 'Found {{count}} resources',
    searchResourcesNoop: 'No resources found',
    searchResourcesError: 'Error searching resources',
    vectorSearchResources: 'Vector search resources',
    vectorSearchResourcesReasoning: 'Vector searching resources',
    vectorSearchResourcesOutput: 'Found {{count}} resources',
    vectorSearchResourcesNoop: 'No resources found',
    vectorSearchResourcesError: 'Error vector searching resources',
    listResources: 'List resources',
    listResourcesReasoning: 'Listing resources',
    listResourcesOutput: 'Listed {{count}} resources',
    listResourcesNoop: 'No resources found',
    listResourcesError: 'Error listing resources',
    selectResource: 'Select resource',
    selectResourceReasoning: 'Presenting resource selection',
    selectResourceOutput: 'Selected resource',
    selectResourceNoop: 'No resource selected',
    selectResourceError: 'Error selecting resource',
    viewResource: 'View resource',
    viewResourceReasoning: 'Viewing resource',
    viewResourceOutput: 'Viewed resource',
    viewResourceError: 'Error viewing resource',
    presentLifeDomains: 'Present life domains',
    presentLifeDomainsReasoning: 'Presenting life domains',
    presentLifeDomainsOutput: 'Presented life domains',
    presentLifeDomainsError: 'Error presenting life domains',
  });
}
